<template>
  <div class="hidden-sm hidden-xs">
    <div class="main-header" v-if="User != ''">
      <!-- Navbar Header -->
      <nav class="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom">
        <div class="container-fluid" style="justify-content: end;">
          <ul class="navbar-nav topbar-nav align-items-center">
            <!-- chamados -->
            <li class="nav-item topbar-icon dropdown hidden-caret" style="padding-right: 15px;"  v-if="User?.tusid !== undefined && User.tusid !== 3">
              <router-link to="/ChamadosAndamento" class="nav-link" id="messageDropdown" role="button"
                aria-haspopup="true" aria-expanded="false" @click="toggleDropdownChamados()">
                <i class="fa fa-envelope"></i>
                <span v-if="ListaChamados.length > 0"
                  class="badge bg-danger rounded-circle position-absolute top-0 start-100 translate-middle"
                  style="line-height: 1;font-size: 13px;">
                  {{ ListaChamados.length }}
                </span>
              </router-link>
            </li>
            <!-- duvidas frequentes -->
            <li class="nav-item topbar-icon dropdown hidden-caret" v-show="false">
              <a class="nav-link dropdown-toggle" href="#" id="notifDropdown" role="button" data-bs-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false" @click="toggleDropdownDuvidas()">
                <i class="fa fa-question"></i>

              </a>
              <ul class="dropdown-menu notif-box animated fadeIn" aria-labelledby="notifDropdown"
                v-if="isDropdownOpenDuvidas">
                <li>
                  <div class="dropdown-title">
                    Dúvidas frequentes
                  </div>
                </li>
                <li>
                  <div class="notif-scroll scrollbar-outer">
                    <div class="notif-center">
                      <a href="#">
                        <div class="notif-icon notif-success">
                          <i class="fa fa-comment"></i>
                        </div>
                        <div class="notif-content">
                          <span class="block"> Lorem, ipsum dolor. </span>
                          <span class="time">Ver</span>
                        </div>
                      </a>
                      <a href="#">
                        <div class="notif-icon notif-success">
                          <i class="fa fa-comment"></i>
                        </div>
                        <div class="notif-content">
                          <span class="block">
                            Lorem ipsum dolor sit.
                          </span>
                          <span class="time">Ver</span>
                        </div>
                      </a>
                      <a href="#">
                        <div class="notif-icon notif-success">
                          <i class="fa fa-comment"></i>
                        </div>
                        <div class="notif-content">
                          <span class="block">
                            Lorem ipsum dolor sit amet.
                          </span>
                          <span class="time">Ver</span>
                        </div>
                      </a>
                      <a href="#">
                        <div class="notif-icon notif-success">
                          <i class="fa fa-comment"></i>
                        </div>
                        <div class="notif-content">
                          <span class="block"> Lorem, ipsum dolor. </span>
                          <span class="time">Ver</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </li>
                <li>
                  <a class="see-all" href="javascript:void(0);">Ver todas as dúvidas<i class="fa fa-angle-right"></i>
                  </a>
                </li>
              </ul>
            </li>
            <!-- ações rápidas -->
            <li class="nav-item topbar-icon dropdown hidden-caret" style="padding-right: 10px;"  v-if="User?.tusid !== undefined && User.tusid !== 3">
              <a class="nav-link" data-bs-toggle="dropdown" href="#" aria-expanded="false"
                @click="toggleDropdownAcoes()">
                <i class="fas fa-layer-group"></i>
              </a>
              <div class="dropdown-menu quick-actions animated fadeIn" v-if="isDropdownOpenAcoes">
                <div class="quick-actions-header">
                  <span class="title mb-1">Ações Rápidas</span>
                </div>
                <div class="quick-actions-scroll scrollbar-outer">
                  <div class="quick-actions-items">
                    <div class="row m-0">
                      <router-link v-if="User.tipo != 3" to="/garantidoras"
                        class="col-6 col-md-4 p-0" @click="toggleDropdownAcoes()">
                        <div class="quick-actions-item">
                          <div class="avatar-item bg-danger rounded-circle">
                            <i class="far fa-address-card"></i>
                          </div>
                          <span class="text">Garantidora</span>
                        </div>
                      </router-link>
                      <router-link to="/imobiliarias" class="col-6 col-md-4 p-0" @click="toggleDropdownAcoes()">
                        <div class="quick-actions-item">
                          <div class="avatar-item bg-warning rounded-circle">
                            <i class="fas fa-warehouse"></i>
                          </div>
                          <span class="text">Imobiliária</span>
                        </div>
                      </router-link>
                      <router-link to="/clientes" class="col-6 col-md-4 p-0"
                        @click="toggleDropdownAcoes()">
                        <div class="quick-actions-item">
                          <div class="avatar-item bg-success rounded-circle">
                            <i class="fas fa-users"></i>
                          </div>
                          <span class="text">Clientes</span>
                        </div>
                      </router-link>
                      <router-link v-if="User.tipo == 1" to="/parceiros" class="col-6 col-md-4 p-0"
                        @click="toggleDropdownAcoes()">
                        <div class="quick-actions-item">
                          <div class="avatar-item bg-success rounded-circle">
                            <i class="fas fa-users"></i>
                          </div>
                          <span class="text">Parceiros</span>
                        </div>
                      </router-link>
                      <router-link to="/listacontratacoes" class="col-6 col-md-4 p-0" @click="toggleDropdownAcoes()">
                        <div class="quick-actions-item">
                          <div class="avatar-item bg-info rounded-circle">
                            <i class="fas fa-cart-plus"></i>
                          </div>
                          <span class="text">Contratação</span>
                        </div>
                      </router-link>

                      <router-link to="/RelatorioContratosAtivos"
                        class="col-6 col-md-4 p-0" @click="toggleDropdownAcoes()">
                        <div class="quick-actions-item">
                          <div class="avatar-item bg-primary rounded-circle">
                            <i class="fas fa-chart-bar"></i>
                          </div>
                          <span class="text">Relatórios</span>
                        </div>
                      </router-link>
                      <router-link to="/ControleCobrancasGarantePay" v-if="User.tipo == 0" class="col-6 col-md-4 p-0" @click="toggleDropdownAcoes()">
                        <div class="quick-actions-item">
                          <div class="avatar-item bg-secondary rounded-circle">
                            <i class="fas fa-credit-card"></i>
                          </div>
                          <span class="text">Financeiro</span>
                        </div>
                      </router-link>
                      <router-link to="/controlecobrancas" v-if="User.tipo != 0" class="col-6 col-md-4 p-0">
                        <div class="quick-actions-item">
                          <div class="avatar-item bg-secondary rounded-circle">
                            <i class="fas fa-credit-card"></i>
                          </div>
                          <span class="text">Financeiro</span>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <!-- meus dados -->
            <li class="nav-item topbar-user dropdown hidden-caret" v-if="User != null">
              <a class="dropdown-toggle profile-pic" data-bs-toggle="dropdown" href="#" aria-expanded="false"
                @click="toggleDropdownUser()">
                <div class="avatar-sm" style="text-align: right;">
                  <img v-if="User != null && User.urlimage != '' && User.urlimage != null" :src="buildFileUrl(User.urlimage)" alt="Usuário"
                    class="avatar-img rounded-circle" style="width: 40px; height: auto" />
                  <img v-else src="/images/userNo.png" alt="Usuário" class="avatar-img rounded-circle"
                    style="width: 40px; height: auto" />
                </div>
                <span class="profile-username">
                  <span class="op-7">Olá,</span>
                  <span class="fw-bold">{{ User.nome }}</span>
                </span>
              </a>
              <ul class="dropdown-menu dropdown-user animated fadeIn" v-if="isDropdownOpenUser">
                <div class="dropdown-user-scroll scrollbar-outer">
                  <li>
                    <div class="user-box">
                      <div class="avatar-lg">
                        <img v-if="User.urlimage != '' && User.urlimage != null" :src="buildFileUrl(User.urlimage)"
                          alt="Usuário" class="avatar-img rounded" style="width: 60px; height: auto" />
                        <img v-else src="/images/userNo.png" alt="Usuário" style="width: 60px; height: auto"
                          class="avatar-img rounded-circle" />
                      </div>
                      <div class="u-text">
                        <h4>{{ User.nome }}</h4>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item2" style="float: left;" href="#" @click.prevent="Logout()">Deslogar</a>
                    <a class="dropdown-item2" style="float: right;" href="#" @click.prevent="Logout()"><i
                        class="fa fa-angle-right"></i></a>
                  </li>
                </div>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
  <div class="hidden-md hidden-lg">
    <v-toolbar>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title style="flex: 3 1!important;">
        <router-link to="/home" class="logo">
          <img v-if="imagemlogo != '' && imagemlogo != null" :src="$imgURL + imagemlogo" alt="navbar brand" class="navbar-brand" height="20" style="width: 100%;height: auto" />
         <img v-else src="/images/logogarantepay.jpg" alt="Usuário" class="avatar-img" style="width: 100%; height: auto" />
        </router-link></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon="mdi-email-outline" to="/ChamadosAndamento" variant="text" v-if="User?.tipo !== undefined && User.tipo !== 3">
      </v-btn>
      <span v-if="User?.tipo !== undefined && User.tipo !== 3 && ListaChamados.length > 0"
         class="badge bg-danger rounded-circle top-0 start-100 translate-middle"
          style="line-height: 1;font-size: 13px;">
          {{ ListaChamados.length }}
        </span> 
      <v-btn icon @click="Logout()">
        <v-icon>mdi-export</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer v-model="drawer"
      style="margin-top: 64px;left:0px ;background: #1a2035 !important;padding-top: 30px;">
      <v-list-item title="Inicio" prepend-icon="mdi-home" to="/home" class="white-text"></v-list-item>
      <v-list v-for="item in GrupoTelas" :key="item.grtId">
        <v-list-group :value="item.grtNome">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" :title="item.grtNome" :prepend-icon="item.grtIcon"
              class="white-text"></v-list-item>
          </template>
          <v-list-item v-for="subItem in Telas.filter(x => x.admGrupoTelas.grtId == item.grtId).sort((a, b) => (a.cdtOrdem - b.cdtOrdem))" :key="subItem.cdtId"
            :value="subItem.cdtNome" :title="subItem.cdtNome" :to="subItem.cdtUrl" prepend-icon="'-'"
            class="white-text">
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import authService from '../auth/oidc';

export default {
  name: 'PageTopo',
  components: {

  },
  data: () => ({
    drawer: false,
    isDropdownOpenChamados: false,
    isDropdownOpenDuvidas: false,
    isDropdownOpenAcoes: false,
    isDropdownOpenUser: false,
     User: { tipo: null,},
    Telas: [],
    GrupoTelas: [],
    ListStatusChamados: [],
    ListaDocumentosResposta: [],
    ListaChamados: [],
    Usuarios: [],
    Usuario: [],
     imagemlogo: '',
  }),
  methods: {
    toggleDropdownChamados() {
      this.isDropdownOpenChamados = !this.isDropdownOpenChamados;
    },
    toggleDropdownDuvidas() {
      this.isDropdownOpenDuvidas = !this.isDropdownOpenDuvidas;
    },
    toggleDropdownAcoes() {
      this.isDropdownOpenAcoes = !this.isDropdownOpenAcoes;
    },
    toggleDropdownUser() {
      this.isDropdownOpenUser = !this.isDropdownOpenUser;
    },
    toggleSidebar() {
      this.$emit('toggle-sidebar');
    },
    formattedDate(value) {
      if (value != null || value != "") {
        return this.$moment(value).format('DD/MM/YYYY HH:mm:ss')
      }
      else {
        return "";
      }

    },
    async Logout() {
      await authService.signOutRedirect()
    },
    buildFileUrl(path) {
      if (!path) return '';
        const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
        const base = this.$imgURL;
        return `${base}/Telas/CadastroUsuarios/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
      },
  },
  async created() {
   const valorArmazenado = localStorage.getItem('_useravgar');
    if (valorArmazenado != '') {
      this.User = JSON.parse(valorArmazenado);
    }
  if (this.User != '' && this.User != null) {
      const gruposDistintos = Array.from(
        new Map(
          this.User.menu
            .filter(x => x.cdtVisivel && x.admGrupoTelas?.grtVisivel) // opcional: só visíveis
            .map(x => [x.admGrupoTelas.grtId, x.admGrupoTelas])       // chave = grtId, valor = objeto do grupo
        ).values()
      ).sort((a, b) => (a.grtOrdem - b.grtOrdem) || a.grtNome.localeCompare(b.grtNome));

      this.GrupoTelas = gruposDistintos;
      this.Telas =  this.User.menu;

      if (this.User.garlogo != '') {
          this.imagemlogo = this.User.garlogo;
        }
    }
   /* await axios.get(`/Process/SupTiposChamados/GetAll`)
      .then(response => {
        this.ListTiposChamados = response.data;
      });

    await axios.get(`/Process/SupStatusChamados/GetAll`)
      .then(response => {
        this.ListStatusChamados = response.data;
        //console.log('this.ListStatusChamados')
        //console.log(this.ListStatusChamados)
      });

    await axios.get(`/Process/SupControleChamados/GetAll`)
      .then(response => {
        this.ListaChamados = response.data;
        //console.log('this.ListaChamados', this.ListaChamados);

        let ListaFinalChamados = [];

        this.ListaChamados.forEach(element => {
          // Encontra o status correspondente ao chamado
          const _statusChamado = this.ListStatusChamados.find(
            x => x.sscId === element.sscId
          );
          // console.log('_statusChamado')
          // console.log(_statusChamado)
          // Se o elemento pertencer ao usuário logado OU se o status permitir que o usuário veja
          if (
            element.tpeId === this.User.tpeid &&
            element.pesPesId === this.User.pesid
          ) {
            ListaFinalChamados.push(element);
          } else if (
            _statusChamado &&
            (this.User.tpeid == 0 ? null : this.User.tpeid) === _statusChamado.tpeId &&
            this.User.tipo === _statusChamado.tusId
          ) {
            ListaFinalChamados.push(element);
          }
        });

        // Substitui ListaChamados pelo array filtrado
        this.ListaChamados = ListaFinalChamados.filter(x => x.sscId != this.ListStatusChamados.filter(w => w.stcId == x.stcId)[this.ListStatusChamados.filter(y => y.stcId == x.stcId).length - 1].sscId);
        //console.log('ListaChamados', this.ListaChamados);
      })
      .catch(err => {
        console.error('Erro ao buscar chamados:', err);
      });
*/

  }
}
</script>

<style>
.dropdown-item2 {
  display: block;
  /* width: 100%; */
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  /* clear: both; */
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
  font-size: 13px;
}
</style>
<style>
/* Make the top bar stick to the viewport top when scrolling */
.main-header {
  position: sticky;
  top: var(--topbar-offset, 0px);
  z-index: 9999;
}

/* Ensure navbar inside header does not add extra top spacing */
.navbar-header {
  margin-top: 0 !important;
}
</style>
